/* eslint-disable eqeqeq */
import {
  Form,
  Card,
  Spin,
  Radio,
  Upload,
  Input,
  Icon,
  Modal,
  Typography,
  Button,
  Checkbox,
  Steps,
} from "antd";
import React, { Component, Fragment } from "react";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import Page from "../general/Page";
import { BackupAndRestoreService } from "../../services/backupAndRestore/BackupAndRestoreService";
import { UserService } from "../../services/user/UserService";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import { CfgOneStepService } from "../../services/cfgOneStep/CfgOneStepService";
import { ReportService } from "../../services/reports/reportService";
import { FileService } from "../../services/file/FileService";
import { handleError } from "../../utils/ErrorHandlers";
import { showErrorToast, showSuccessToast } from "../general/ToastHelper";
import { Translation } from "react-i18next";
import i18next from "i18next";

import "./BackupAndRestore.css";

const { Text, Paragraph } = Typography;
var CryptoJS = require("crypto-js");
class BackupAndRestore extends Component {
  constructor(props) {
    super(props);
    console.log(props)
    this.props.context.setCurrentComponent("BackupAndRestore");
    this.backupRestoreService = new BackupAndRestoreService();
    this.userService = new UserService();
    this.groupService = new AccountGroupService();
    this.reportService = new ReportService();
    // this.oneStepFlow = new CfgOneStepService();
    this.fileService = new FileService();

    this.state = {
      isFetching: false,
      isLoading: false,
      isuploading: false,
      operation: "backup",
      configuredValues: [],
      accountConfigurationsCount: [],
      configurationsCount: {},
      usersAndGroupsConfigurations: [],
      usersAndGroupsRestore: [],
      crmConfigurations: [],
      crmRestore: [],
      file: null,
      promptsFile: null,
      callFlowsFile: null,
      fileUploaded: false,
      showModal: false,
      backupFileName: "",
      agentGroups: [],
      inboundGroups: [],
      usersWithCfg: [],
      groupsWithCfg: [],
      configurationsFile: {
        accountAgentsGroupWithCFG: [],
        customUserWithCFG: [],
        agentChangeState: [],
        usersGroups: [],
        accountInboundsGroupWithCFG: [],
        // cfgOneSteps: [],
      },
      crmConfigurationsFile: {},
      current: 0,
      status: "",
      steps: [
        {
          title: i18next.t("Users And Groups"),
          icon: <Icon type="team" />,
        },
        {
          title: i18next.t("Prompts"),
          icon: <Icon type="audio" />,
        },
        {
          title: i18next.t("Call Flows"),

          icon: <Icon type="control" />,
        },
        {
          title: i18next.t("CRM"),
          icon: <Icon type="smile-o" />,
        },
      ],
      crmFlag: false,
      usersAndGroupsFlag: false,
      promptsFlag: false,
      callFlowFlag: false,
      backupAdminData:{}
    };
  }

  async componentDidMount() {
    try {
      let {
        accountConfigurationsCount,
        configurationsCount,
        crmFlag,
        usersAndGroupsFlag,
        promptsFlag,
        callFlowFlag,
      } = this.state;
      this.setState({ isFetching: true });
      let data = await this.backupRestoreService.getAccountConfigurationsCount(
        this.props.context.session_id
      );
      accountConfigurationsCount = data.ivrCustomEntityObject;
      accountConfigurationsCount.forEach((item) => {
        configurationsCount[item.key] = item.value;
      });
      // console.log(configurationsCount);
      // //setFlagsHere
      // console.log(crmFlag, usersAndGroupsFlag, promptsFlag, callFlowFlag);
      if (
        configurationsCount.customersCount == 0 &&
        configurationsCount.ticketsCategories == 0 &&
        configurationsCount.ticketsCount == 0
      ) {
        crmFlag = true;
      }
      if (
        configurationsCount.adminsCount == 1 &&
        configurationsCount.agentsCount == 0 &&
        configurationsCount.agentsGroupsCount == 0 &&
        configurationsCount.inboundsGroupsCount == 0 &&
        configurationsCount.usersGroupsCount == 0
      ) {
        usersAndGroupsFlag = true;
      }
      if (configurationsCount.callFlowsCount == 0) {
        callFlowFlag = true;
      }
      if (configurationsCount.promptsCount == 0) {
        promptsFlag = true;
      }

      this.setState({
        isFetching: false,
        crmFlag,
        usersAndGroupsFlag,
        callFlowFlag,
        promptsFlag,
      });
      // console.log(crmFlag, usersAndGroupsFlag, promptsFlag, callFlowFlag);
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  FillConfigurationsFile(
    agentsGroups,
    users,
    agentChangeState,
    usersGroups,
    inboundGroups,
    // cfgOneSteps,
    accountMaxConCalls,
    accountAgentsMaxNumber,
    backupAdmin
  ) {
    let { configurationsFile } = this.state;
    configurationsFile.accountAgentsGroupWithCFG = agentsGroups;
    configurationsFile.customUserWithCFG = users;
    configurationsFile.agentChangeState = agentChangeState;
    configurationsFile.usersGroups = usersGroups;
    configurationsFile.accountInboundsGroupWithCFG = inboundGroups;
    // configurationsFile.cfgOneSteps = [cfgOneSteps];
    configurationsFile.accountMaxConCalls = accountMaxConCalls;
    configurationsFile.accountAgentsMaxNumber = accountAgentsMaxNumber;
    configurationsFile.backupAdminData = backupAdmin;
    this.setState({ configurationsFile });
    
  }

  FillCrmConfigurationsFile(
    customers,
    tickets,
    ticketCategories,
    ticketComments,
    ticketSummary,
    ticketTracings
  ) {
    let { crmConfigurationsFile } = this.state;
    crmConfigurationsFile.customers = customers;
    crmConfigurationsFile.tickets = tickets;
    crmConfigurationsFile.ticketCategories = ticketCategories;
    crmConfigurationsFile.ticketComments = ticketComments;
    crmConfigurationsFile.ticketSummary = ticketSummary;
    crmConfigurationsFile.ticketTracings = ticketTracings;
  }

  onChange = (e) => {
    this.setState({ operation: e.target.value });
  };

  hanndleCancel = () => {
    this.setState({
      file: null,
      isuploading: false,
    });
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  getConfiguredValues() {
    let value = this.state.configuredValues.forEach((value) => {
      return value;
    });

    return value;
  }

  handleUpload = async (e) => {
    let { current } = this.state;

    let obj = {};
    const reader = new FileReader();
    try {
      reader.onload = async () => {
        const text = reader.result;
        obj = text;
        switch (current) {
          case 0:
            e.file.type == "application/json"
              ? this.setState({
                  usersAndGroupsRestore: JSON.parse(obj),
                  isuploading: false,
                })
              : this.errorUploadJsonFunction();
            break;

          case 1:
            e.file.type == "application/zip" ||
            e.file.type == "application/x-zip-compressed"
              ? this.setState({
                  promptsFile: e.file,
                  isuploading: false,
                  fileUploaded: true,
                })
              : this.errorUploadZipFunction();
            break;
          case 2:
            e.file.type == "application/zip" ||
            e.file.type == "application/x-zip-compressed"
              ? this.setState({
                  callFlowsFile: e.file,
                  isuploading: false,
                  fileUploaded: true,
                })
              : this.errorUploadZipFunction();
            break;

          case 3:
            e.file.type == "application/json"
              ? this.setState({
                  crmRestore: JSON.parse(obj),
                  isuploading: false,
                  fileUploaded: true,
                })
              : this.errorUploadJsonFunction();
            break;

          default:
            break;
        }
      };
    } catch (error) {
      handleError(error);
    }

    reader.readAsText(e.file);
  };

  errorUploadJsonFunction() {
    this.setState({
      file: null,
      isuploading: false,
    });
    showErrorToast(i18next.t("file is not json type"));
  }
  errorUploadZipFunction() {
    this.setState({
      file: null,
      isuploading: false,
    });
    showErrorToast(i18next.t("file is not zip type"));
  }
  handleRestore = async () => {
    let { current } = this.state;
    try {
      this.setState({ isLoading: true });
      var decryptedData;
      switch (current) {
        case 0:
          decryptedData = this.dataDecryption(this.state.usersAndGroupsRestore);
          await this.backupRestoreService.restoreUsersAndGroupsConfigurations(
            this.props.context.session_id,
            decryptedData
          );
          showSuccessToast(i18next.t("Users And Groups Restored Successfuly"));
          // this.setState({ isLoading: false });
          break;

        case 1:
          await this.backupRestoreService.restorePrompts(
            this.props.context.session_id,
            this.state.promptsFile
          );
          showSuccessToast(i18next.t("Prompts Restored Successfuly"));
          break;
        case 2:
          await this.backupRestoreService.restoreCallFlows(
            this.props.context.session_id,
            this.state.callFlowsFile
          );
          showSuccessToast(i18next.t("Call Flows Restored Successfuly"));
          break;

        case 3:
          decryptedData = this.dataDecryption(this.state.crmRestore);
          await this.backupRestoreService.restoreCrmConfigurations(
            this.props.context.session_id,
            decryptedData
          );
          showSuccessToast(i18next.t("CRM Restored Successfuly"));
          break;

        default:
          break;
      }

      this.setState({ isLoading: false, file: null });
    } catch (error) {
      this.setState({ isLoading: false });
      handleError(error);
    }
  };

  backupSync = async () => {
    try {
      this.setState({ isLoading: true });
      this.state.configuredValues.forEach((value) => {
        if (value === "UsersAndGroups") this.AllConfigBackup();
        if (value === "Prompts") this.promptsBackup();
        if (value === "CallFlows") this.callFlowsBackup();
        if (value === "CRM") this.crmBackup();
      });

      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
      handleError(error);
    }
  };
  getBackupFileName = (e) => {
    this.setState({ backupFileName: e.target.value });
    e.target.value = "";
  };

  callFlowsBackup = async () => {
    try {
      let data = await this.backupRestoreService.downloadCallFlowsBackupFolder(
        this.props.context.session_id,
        this.state.backupFileName
      );
    } catch (error) {
      handleError(error);
    }
  };

  promptsBackup = async () => {
    try {
      let data = await this.backupRestoreService.downloadPromptsBackupFolder(
        this.props.context.session_id,
        this.state.backupFileName
      );
    } catch (error) {
      handleError(error);
    }
  };
  crmBackup = async () => {
    let { crmConfigurations } = this.state;
    try {
      let data = await this.backupRestoreService.downloadCrmBackupFile(
        this.props.context.session_id
      );
      let dataConfig = [];
      dataConfig = data.ivrCustomEntityObject;
      dataConfig.forEach((item) => {
        crmConfigurations[item.key] = item.value;
      });

      this.FillCrmConfigurationsFile(
        crmConfigurations.customers.ivrList,
        crmConfigurations.tickets.ivrList,
        crmConfigurations.ticketCategories.ivrList,
        crmConfigurations.ticketComments.ivrList,
        crmConfigurations.ticketSummary.ivrCustomEntityObject,
        crmConfigurations.ticketTracings.ivrList
      );
      var encryptedData = this.dataEncryption(this.state.crmConfigurationsFile);
      this.downlaodFile(encryptedData, this.state.backupFileName + "_CRM");
    } catch (error) {
      handleError(error);
    }
  };
  AllConfigBackup = async () => {
    let { usersAndGroupsConfigurations, inboundGroups, agentGroups } =
      this.state;
    try {
      let data =
        await this.backupRestoreService.downloadUsersAndGroupsBackupFile(
          this.props.context.session_id
        );

      let dataConfig = [];
      dataConfig = data.ivrCustomEntityObject;
      dataConfig.forEach((item) => {
        usersAndGroupsConfigurations[item.key] = item.value;
      });

      this.groupDataAndCfgMapping(
        usersAndGroupsConfigurations.accountGroups.ivrList,
        usersAndGroupsConfigurations.accountGroups.cfgList
      );

      this.userDataAndCfgMapping(
        usersAndGroupsConfigurations.usersList.ivrList,
        usersAndGroupsConfigurations.usersList.cfgList
      );

      inboundGroups = this.state.groupsWithCfg.filter(
        (element) => element.groupType === "IBG"
      );
      agentGroups = this.state.groupsWithCfg.filter(
        (element) => element.groupType === "SXG"
      );

      this.FillConfigurationsFile(
        agentGroups,
        this.state.usersWithCfg,
        usersAndGroupsConfigurations.agentChangeStateList.ivrList,
        usersAndGroupsConfigurations.usersGroupsList.ivrList,
        inboundGroups,
        // usersAndGroupsConfigurations.cfgOneSteps.ivrCustomEntityObject,
        usersAndGroupsConfigurations.accountMaxConCalls,
        usersAndGroupsConfigurations.accountAgentsMaxNumber,
        this.state.backupAdminData
      );

      var encryptedData = this.dataEncryption(this.state.configurationsFile);

      this.downlaodFile(encryptedData, this.state.backupFileName + "_UG");
    } catch (error) {
      handleError(error);
    }
  };

  downlaodFile(content, filename) {
    var dataStr =
      "data:text/json;charset=utf-8," +
      encodeURIComponent(JSON.stringify(content));

    var dlAnchorElem = window.document.createElement("a");
    dlAnchorElem.setAttribute("href", dataStr);
    dlAnchorElem.setAttribute("download", filename + ".json");
    dlAnchorElem.click();
  }

  userDataAndCfgMapping(data, cfgData) {
    let adminData = {};
    let filtered = [];
    data.forEach((element, index) => {
      if (element.userId == this.props.context.user.userId) {
        adminData = element;
      } else {
        filtered = data.filter((value) => {
          return value.userId != this.props.context.user.userId;
        });
      }
    });
    filtered.forEach((element, index) => {
      let cfgtest = cfgData.filter(
        (cfgEl) =>
          element.accountId === cfgEl.accountId &&
          element.userId === cfgEl.userId
      );
      filtered[index].cfg = cfgtest;
    });

    this.setState({
      usersWithCfg: filtered,
      backupAdminData: adminData,
      isLoading: false,
    });
  }

  groupDataAndCfgMapping(data, cfgData) {
    data.forEach((element, index) => {
      let cfgtest = cfgData.filter(
        (cfgEl) =>
          element.accountId === cfgEl.accountId &&
          element.groupId === cfgEl.groupId
      );

      data[index].cfg = cfgtest;
    });

    this.setState({ groupsWithCfg: data, isLoading: false });
  }

  onCheckboxsChange = (checkedValues) => {
    this.setState({ configuredValues: checkedValues });
  };

  handleOk = () => {
    this.setState({ showModal: false });
    this.state.operation === "backup"
      ? this.backupSync()
      : this.handleRestore();
  };

  handleCancel = () => {
    this.setState({
      showModal: false,
    });
  };

  next = () => {
    let { current, steps } = this.state;
    steps.at(current).status = "wait";
    current += 1;
    steps.at(current).status = "process";
    this.setState({ current, steps });
  };
  prev = () => {
    let { current, steps } = this.state;
    steps.at(current).status = "wait";
    current -= 1;
    steps.at(current).status = "process";
    this.setState({ current, steps });
  };

  dataEncryption(configurationsFile) {
    var encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(configurationsFile),
      "secret key"
    ).toString();

    return encryptedData;
  }

  dataDecryption(configurationsFile) {
    var bytes = CryptoJS.AES.decrypt(configurationsFile, "secret key");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    return decryptedData;
  }
  render() {
    let { isFetching, current, steps, configurationsCount } = this.state;

    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const options = [
      { label: i18next.t("Groups And Users"), value: "UsersAndGroups" },
      { label: i18next.t("Prompts"), value: "Prompts" },
      { label: i18next.t("Call Flows"), value: "CallFlows" },
      { label: i18next.t("CRM"), value: "CRM" },
    ];

    const props = {
      beforeUpload: (file) => {
        file.type === "application/json" ||
        file.type === "application/zip" ||
        file.type === "application/x-zip-compressed"
          ? this.setState((state) => ({
              file: file,
            }))
          : showErrorToast(
              i18next.t("only file with type json or zip is accepted")
            );
        return false;
      },
      accept: ".json, .zip",
    };
    const { Step } = Steps;
    return (
      <Translation>
        {(t) => (
          <Page title={t("Backup And Restore")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    <Radio.Group
                      onChange={this.onChange}
                      value={this.state.operation}
                    >
                      <Radio value={"backup"}>{t("Backup")}</Radio>
                      <Radio value={"restore"}>{t("Restore")}</Radio>
                    </Radio.Group>
                    {this.state.operation === "backup" ? (
                      <div style={{ marginTop: 40 }}>
                        <span> {t("Backup :")} </span>
                        <Checkbox.Group
                          options={options}
                          onChange={this.onCheckboxsChange}
                          style={{ marginLeft: 10 }}
                        />
                      </div>
                    ) : (
                      <div>
                        <div style={{ marginTop: 40 }}>
                          <Steps current={current}>
                            {steps.map((item) => (
                              <Step
                                key={item.title}
                                title={item.title}
                                icon={item.icon}
                                status={item.status}
                              />
                            ))}
                          </Steps>

                          <div>
                            {current < steps.length - 1 && (
                              <Button
                                style={{ marginTop: 40 }}
                                type="primary"
                                onClick={() => this.next()}
                              >
                                {t("Next")}
                              </Button>
                            )}
                            {current > 0 && (
                              <Button
                                style={{ marginTop: 40, marginLeft: 8 }}
                                onClick={() => this.prev()}
                              >
                                {t("Previous")}
                              </Button>
                            )}
                            <Upload
                              {...props}
                              showUploadList={false}
                              onChange={this.handleUpload}
                            >
                              <Button
                                style={
                                  this.props.context.curr_dir === "ltr" &&
                                  this.props.context.curr_lang === "en"
                                    ? {
                                        marginLeft: "40px",
                                        marginBottom: "25px",
                                      }
                                    : {
                                        marginRight: "40px",
                                        marginBottom: "25px",
                                      }
                                }
                              >
                                <Icon type="upload" style={{ color: "" }} />
                                {this.state.file === null
                                  ? t("Select File")
                                  : this.state.file.name}
                              </Button>
                            </Upload>

                            {this.state.file === null ? null : (
                              <Fragment>
                                {/* <Button
                              type="primary"
                              onClick={this.handleUpload}
                              loading={this.state.isuploading}
                              style={{ marginLeft: 20 }}
                            >
                              {this.state.isuploading
                                ? "Uploading"
                                : "Start Upload"}
                            </Button> */}
                                <Button
                                  icon="delete"
                                  onClick={this.hanndleCancel}
                                  style={{ marginLeft: 20 }}
                                ></Button>
                              </Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </Form>

                  <Form.Item
                    wrapperCol={{
                      xs: { span: 24, offset: 0 },
                      sm: { span: 16, offset: 8 },
                    }}
                  >
                    {/* <Popconfirm
                  title={
                    this.state.operation === "restore"
                      ? "Are you sure you want to backup "
                      : "Are you sure you want to restore "
                  }
                  onConfirm={
                    this.state.operation === "backup"
                      ? this.backupSync
                      : this.handleRestore
                  }
                  okText="Yes"
                  cancelText="No"
                >
             
                </Popconfirm> */}

                    <Button
                      className="button-submit"
                      type="primary"
                      size={"small"}
                      loading={this.state.loading}
                      onClick={this.showModal}
                      disabled={
                        (this.state.configuredValues.length === 0 &&
                          this.state.operation === "backup") ||
                        (this.state.operation === "restore" &&
                          this.state.file == null)
                          ? true
                          : false
                      }
                    >
                      {this.state.operation === "backup"
                        ? t("Backup")
                        : t("Restore")}
                    </Button>
                  </Form.Item>
                </Card>
              </div>
            )}

            <Modal
              title={
                this.state.operation === "backup"
                  ? t(" Confirm Backup ")
                  : t(" Confirm Restore")
              }
              visible={this.state.showModal}
              //onOk= {this.handleOk}
              onCancel={this.handleCancel}
              footer={[
                <Button type="primary" key="Cancel" onClick={this.handleCancel}>
                  {t("Cancel")}
                </Button>,
                <Button
                  type="primary"
                  key="Ok"
                  onClick={this.handleOk}
                  disabled={
                    this.state.backupFileName == "" &&
                    this.state.operation === "backup"
                      ? true
                      : false
                  }
                >
                  {t("Ok")}
                </Button>,
              ]}
            >
              {this.state.operation === "backup" ? (
                <div>
                  <Paragraph>
                    <Text strong>
                      {" "}
                      {t(
                        "You are about to backup the following configurations:"
                      )}
                    </Text>
                    <ul>
                      {this.state.configuredValues.includes(
                        "UsersAndGroups"
                      ) ? (
                        <div>
                          <li>
                            <Text>
                              {configurationsCount.agentsGroupsCount}
                              {configurationsCount.agentsGroupsCount < 2
                                ? t(" Agent group")
                                : t(" Agents groups ")}{" "}
                              and {configurationsCount.usersGroupsCount}
                              {configurationsCount.usersGroupsCount < 2
                                ? t(" group is assigned ")
                                : t(" groups are assigned ")}
                            </Text>
                          </li>
                          <li>
                            <Text>
                              {configurationsCount.inboundsGroupsCount}
                              {configurationsCount.inboundsGroupsCount < 2
                                ? t("  Inbound Group")
                                : t("  Inbound Groups")}{" "}
                            </Text>
                          </li>

                          <li>
                            <Text>
                              {configurationsCount.agentsCount}
                              {configurationsCount.agentsCount < 2
                                ? t("   Agent ")
                                : t("   Agents ")}
                            </Text>
                          </li>
                          <li>
                            <Text>
                              {configurationsCount.adminsCount}
                              {configurationsCount.adminsCount < 2
                                ? t(" Admin")
                                : t(" Admins")}
                            </Text>
                          </li>
                        </div>
                      ) : (
                        <></>
                      )}
                      {this.state.configuredValues.includes("Prompts") ? (
                        <li>
                          <Text>
                            {configurationsCount.promptsCount}{" "}
                            {configurationsCount.promptsCount < 2
                              ? t(" Prompt")
                              : t(" Prompts")}
                          </Text>
                        </li>
                      ) : (
                        <></>
                      )}
                      {this.state.configuredValues.includes("CallFlows") ? (
                        <li>
                          <Text>
                            {configurationsCount.callFlowsCount}
                            {configurationsCount.callFlowsCount < 2
                              ? t(" Call Flow")
                              : t(" Call Flows")}
                          </Text>
                        </li>
                      ) : (
                        <></>
                      )}
                      {this.state.configuredValues.includes("CRM") ? (
                        <div>
                          {" "}
                          <li>
                            <Text>
                              {configurationsCount.customersCount}
                              {configurationsCount.customersCount < 2
                                ? " Customer"
                                : " Customers"}
                            </Text>
                          </li>
                          <li>
                            <Text>
                              {configurationsCount.ticketsCount}
                              {configurationsCount.ticketsCount < 2
                                ? " Ticket"
                                : " Tickets"}{" "}
                            </Text>
                          </li>
                          <li>
                            <Text>
                              {configurationsCount.ticketsCategories}
                              {configurationsCount.ticketsCategories < 2
                                ? " Ticket Category"
                                : " Ticket Categories"}
                            </Text>
                          </li>
                        </div>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </Paragraph>
                  <Form.Item
                    label={t("File Name")}
                    labelCol={{ span: 4 }}
                    wrapperCol={{
                      span: 18,
                    }}
                  >
                    <Input
                      id="filename"
                      onChange={this.getBackupFileName}
                      style={{ marginLeft: 10 }}
                    ></Input>
                  </Form.Item>
                </div>
              ) : (
                <Paragraph>
                  {t("Are you sure you want to restore")}{" "}
                  <Text strong> {t(steps[current].title)}</Text> ?
                </Paragraph>
              )}
            </Modal>
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(BackupAndRestore))
);
